import React, { PropTypes } from 'react';

import './styles.scss';

export const Textarea = props => (
  <div className={`textarea ${props.className}`}>
    <label>{props.name}</label>
    <textarea
      rows={props.rows}
      onChange={props.onChange}
      placeholder={props.placeholder}
    />
  </div>
);

Textarea.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  name: PropTypes.string,
  rows: PropTypes.string,
  placeholder: PropTypes.string,
};


export default Textarea;



// WEBPACK FOOTER //
// ./src/components/shared/textarea/main.jsx